import { IconBack } from "app/components/Icon/Icon";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
//
type Props = {
  selectedTab: string;
  onClickBack: (...args: Array<any>) => any;
};
//
export const TabTypes = {
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
};

class FormSubmittedHeaderDesktop extends Component<Props> {
  render(): React.ReactElement<React.ComponentProps<"div">, "div"> {
    const { selectedTab, onClickBack } = this.props;
    return (
      <div className="form-submitted__header">
        <div className="form-submitted__header__title">
          <div onClick={onClickBack} className="title__back">
            <IconBack />
            <FormattedMessage tagName="span" id="events-dashboard-back" />
          </div>
          {selectedTab === TabTypes.DEPOSIT && (
            <FormattedMessage tagName="span" id="cashier-deposit-button" />
          )}
          {selectedTab === TabTypes.WITHDRAW && (
            <FormattedMessage tagName="span" id="cashier-withdraw-button" />
          )}
          <div />
        </div>
      </div>
    );
  }
}

export default FormSubmittedHeaderDesktop;
